import { Drawer } from '@mui/material'
import { NavLink } from 'react-router-dom'




function ReportNav({reportNavStatus,setReportNavStatus}) {
  
  return (
    <Drawer 
      open={reportNavStatus} 
      onClose={()=>setReportNavStatus(!reportNavStatus)}  
      anchor='right'
    >
      <div className='row'>
        <ul class="list-group" style={{minWidth:350}}>
          <NavLink to="/finance/report/daybook" className='list-group-item'>Day Book</NavLink>
          <NavLink to="/finance/report/gstr1" className='list-group-item'>GSTR1</NavLink>
          <NavLink to="/finance/report/gstr2" className='list-group-item'>GSTR2</NavLink>
          <NavLink to="/finance/report/gstr3b" className='list-group-item'>GSTR3B</NavLink>
          {/*
          <NavLink to="/finance/report/daybook" className='list-group-item'>Day Book</NavLink>
          <NavLink to="/finance/report/daybook" className='list-group-item'>Day Book</NavLink>
          <NavLink to="/finance/report/daybook" className='list-group-item'>Day Book</NavLink>
          <NavLink to="/finance/report/daybook" className='list-group-item'>Day Book</NavLink>
          <NavLink to="/finance/report/daybook" className='list-group-item'>Day Book</NavLink>
          <NavLink to="/finance/report/daybook" className='list-group-item'>Day Book</NavLink>
          <NavLink to="/finance/report/daybook" className='list-group-item'>Day Book</NavLink>
          <NavLink to="/finance/report/daybook" className='list-group-item'>Day Book</NavLink>
          */}
        </ul>
        </div>
    </Drawer>
  )
}

export default ReportNav